import { GenericErrorCard } from '@components/RouteComponents/GenericErrorCard'
import { routeTree } from '@src/routeTree.gen'
import { store } from '@store/index'
import { createRouter } from '@tanstack/react-router'

import { fireMixpanelEvent } from './analytics'
import { queryClient } from './queryClient'

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export const routerContext = {
  queryClient,
  store,
  fireMixpanelEvent,
}

export const router = createRouter({
  routeTree,
  context: routerContext,
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: GenericErrorCard,
})
